import React, { useState } from 'react';
import axios from 'axios';
import growth from '../../images/growth.svg';
import wordisKing from '../../images/icons/word-of-mouth-is-king.svg';
import massivepotential from '../../images/icons/visibility.svg';
import revenuemodel from '../../images/icons/revenuemodel.svg';
import firstmover from '../../images/icons/reward.svg';
import open from '../../images/icons/open.svg';
import close from '../../images/icons/close.svg';
import cancel from '../../images/icons/cancelpop.svg';
import invisible from '../../images/icons/invisible.svg';
import trust from '../../images/icons/trust.svg';
import lightning from '../../images/icons/lightning.svg';

export default function InvestorPage() {
  const [currentFaq, setCurrentFaq] = useState();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const faqs = [
    { id: 1, question: 'Do I need to be in South Africa to become a partner?', answer: 'No! You can become a partner from anywhere' },
    { id: 2, question: 'Do I need to be in specific field to become a partner?', answer: 'No, you can be in any profession and become a partner.' },
  ];

  const changeFaq = (faq) => {
    setCurrentFaq(currentFaq === faq ? 0 : faq);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const [contactDataFull, setContactDataFull] = useState({leadType:2})

  const handleSubmit = async () => {
    if(!formData.name | !formData.message | !contactDataFull.email){
        alert('Please fill all required fields')
        return
    }
    contactDataFull.capturedData = JSON.stringify(formData) 
    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}/Lead/Create`, JSON.stringify(contactDataFull), {
        headers: { 'Content-Type': 'application/json' },
      });
      alert('Message sent successfully!');
      setShowModal(false);
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      alert('There was an error. Please try again.');
    }
  };

  return (
    <div className="relative font-sans">
      {/* Overlay */}
      {showModal && <div className="fixed inset-0 bg-black opacity-50 z-40"></div>}

      {/* Modal */}
      {showModal && (
        <div className="fixed z-50 inset-0 flex items-center justify-center">
          <div className="bg-white grid grid-cols-2 rounded-xl shadow-lg w-11/12 md:w-6/12 p-6 relative gap-x-2 gap-y-2">
            <div className='flex flex-row justify-between col-span-2 items-center'>
                <h2 className="text-[28px] text-start font-[500] mb-4 text-[#101828]">Send Us A Message</h2>
                <div onClick={() => setShowModal(false)} className="text-gray-500 hover:underline">
                    <img src={cancel} />
                </div>
            </div>
            <div className='flex flex-col space-y-2 col-span-1'>
                <label className='text-start text-[14px] font-[500] text-[#344054]'>Name</label>
                <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your full Name"
                className="w-full border border-gray-300 rounded-md p-2 mb-3"
                />
            </div>
            <div className='flex flex-col space-y-2 col-span-1'>
                <label className='text-start text-[14px] font-[500] text-[#344054]'>Email Address</label>
                <input
              name="email"
              value={contactDataFull.email}
              onChange={(e) => setContactDataFull({...contactDataFull,email:e.target.value})} 
              placeholder="Your Email"
              className="w-full border border-gray-300 rounded-md p-2 mb-3"
            />
            </div>

            <div className='flex flex-col space-y-2 col-span-1'>
                <label className='text-start text-[14px] font-[500] text-[#344054]'>Phone Number (Optional)</label>
                <input
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              placeholder="Your Phone number"
              className="w-full border border-gray-300 rounded-md p-2 mb-3"
            />
            </div>

            <div className='flex flex-col space-y-2 col-span-2'>
                <label className='text-start text-[14px] font-[500] text-[#344054]'>Your message</label>
                <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              className="w-full border border-gray-300 rounded-md p-2 mb-4 col-span-2"
              rows={4}
            ></textarea>
            </div>

            <div className="flex justify-between col-span-2 mt-4">
              <button onClick={handleSubmit} className="bg-[#008B39] w-full text-white px-4 py-2 rounded-[32px] hover:bg-[#006f2e]">
                Submit
              </button>

            </div>
          </div>
        </div>
      )}

      {/* Hero */}
      <section className="bg-[url('images/partnerhero.svg')] bg-cover bg-center bg-no-repeat px-6 py-20 text-center text-white">
        <h1 className="text-3xl md:text-5xl font-bold mb-4">Unlocking the Future of Service<br/> Connections</h1>
        <p className="max-w-2xl mx-auto mb-6">
          Yebokenny is helping businesses grow through positive recommendation. We’re building a platform for trusted business discovery and we want you to be a part of it.
        </p>
        {/* <button onClick={() => setShowModal(true)} className="bg-white text-[#008B39] font-semibold py-2 px-6 rounded-full hover:bg-gray-200 transition">
          Contact Us
        </button> */}
      </section>

      {/* Vision & Mission */}
      <section className="py-16 px-5 lg:px-20 bg-white text-center flex flex-col space-y-10 lg:space-y-0 lg:flex-row lg:justify-between bg-[#008B390A]">
          <div className='lg:hidden text-[24px] font-[700] text-[#0D0D0D]'>A Global Problem.</div>
          <div className='hidden lg:flex text-[64px] font-[700] text-[#0D0D0D] leading-[140%]'>A Global<br/>Problem.</div>
          
          <div className='flex flex-col space-y-3'>
            <div className='rounded-[8px] flex flex-col space-x-4 py-3 text-start bg-[#FFFFFF] border-[1px] w-full lg:w-[577px]'>
              <span><img src={invisible} /></span>
              <div className='flex flex-col space-y-1'>
                <span className='text-[#0E0E0E] text-[22px]'>Invisibility</span>
                <span className='text-[#737373] text-[16px]'>Billions are spent yearly on services. Many talented providers remain invisible, underpaid, or under-utilized.</span>
              </div>
            </div>

            <div className='rounded-[8px] flex flex-col space-x-4 py-3 text-start bg-[#FFFFFF] border-[1px] w-full lg:w-[577px]'>
              <span><img src={trust} /></span>
              <div className='flex flex-col space-y-1'>
                <span className='text-[#0E0E0E] text-[22px]'>Lack of Trust</span>
                <span className='text-[#737373] text-[16px]'>Customers struggle with access, reliability, and assurance. The world needs a better way to connect, book, and review services.</span>
              </div>
            </div>
          </div>
      </section>

      {/* Why Invest */}
      <section className="py-20 px-6 bg-[#008B39] text-white text-center">
        <h2 className="text-4xl font-semibold mb-12">Our Vision is Bold, Yet Simple</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          <div className="col-span-2 flex flex-col items-center">
            <img src={wordisKing} alt="" />
            <h4 className="font-bold mb-2">Trusted Marketplace</h4>
            <p className="text-sm">Creating a trusted marketplace built on real recommendations, not fake reviews.</p>
          </div>
          <div className="col-span-2 flex flex-col items-center">
            <img src={massivepotential} alt="" />
            <h4 className="font-bold mb-2">Visibility & Credibility</h4>
            <p className="text-sm">Offering visibility and credibility to local artisans and freelancers.</p>
          </div>
          <div className="col-span-2 flex flex-col items-center">
            <img src={firstmover} alt="" />
            <h4 className="font-bold mb-2">Reward System</h4>
            <p className="text-sm">Providing a rewards system that values social referrals and customer loyalty.</p>
          </div>
          <div className="col-span-2 flex flex-col items-center">
            <img src={revenuemodel} alt="" />
            <h4 className="font-bold mb-2">Opportunity for SMEs</h4>
            <p className="text-sm">Opening a gateway for SMEs to be discovered, reviewed, and booked in real-time.</p>
          </div>
        </div>
      </section>

      <div className='flex flex-col px-10 lg:px-20 lg:py-20 mb-10'>
      <div className='text-[30px] lg:text-[48px] font-[400] mb-3 lg:mb-0'>Why Yebokenny Is<br/>Different</div>
      <div className='grid grid-cols-6 gap-y-5 lg:gap-y-0 lg:gap-x-5 mt-5 lg:mt-10'>
          <div className='col-span-6 lg:col-span-2 bg-[#FBFBFB] flex flex-col text-start space-y-4 rounded-[4px] p-3'>
              <span><img src={lightning} /></span>
              <span className='flex flex-col'>
                  <span className='text-[#121212] text-[20px] font-[500]'>Quality Over Quantity</span>
                  <span className='text-[#6D7076] text-[16px]'>Our system promotes verified, trusted artisans through a dynamic recommendation economy.</span>
              </span>
          </div>
          <div className='col-span-6 lg:col-span-2 bg-[#FBFBFB] flex flex-col text-start space-y-4 rounded-[4px] p-3'>
              <span><img src={lightning} /></span>
              <span className='flex flex-col'>
                  <span className='text-[#121212] text-[20px] font-[500]'>Community-Driven Platform</span>
                  <span className='text-[#6D7076] text-[16px]'>We're building a community, not just a platform – where users are rewarded for spreading trust.</span>
              </span>
          </div>
          <div className='col-span-6 lg:col-span-2 bg-[#FBFBFB] flex flex-col text-start space-y-4 rounded-[4px] p-3'>
              <span><img src={lightning} /></span>
              <span className='flex flex-col'>
                  <span className='text-[#121212] text-[20px] font-[500]'>Local-First & Scalable</span>
                  <span className='text-[#6D7076] text-[16px]'>Our model is designed to be inclusive and tailored to meet the needs of emerging markets.</span>
              </span>
          </div>
      </div>
  </div>


      {/* Call to Action */}
      <section className="mx-5 mb-20 rounded-[24px] bg-[url('images/join.svg')] bg-cover bg-center bg-no-repeat px-6 py-16 text-center text-white lg:mx-20">
        <h2 className="font-bold mb-4 text-[24px] lg:text-[68px]">We're Opening to Partners</h2>
        <p className="mb-6 text-[16px] lg:text-[24px]">We're currently exploring strategic collaborations and investor relationships that align with our mission and values.</p>
        <button onClick={() => setShowModal(true)} className="bg-white text-[#008B39] text-[16px] lg:text-[24px] font-semibold py-2 px-6 rounded-full hover:bg-gray-200 transition">
          Contact Us
        </button>
        {/* <div className='flex flex-col font-semibold'>
          <span>Tommi Emedo,</span>
          <span>Group Country Director</span>
          <span>Email: tommi@yebokenny.com</span>
          <span>Phone: +2348034969690</span>
        </div> */}
      </section>
    </div>
  );
}
